// @flow
import { format } from "date-fns";
import wro from "@tvg/api/wro";
import type { WroResponse } from "@tvg/api/wro/types";

export default (accountNumber: string): Promise<WroResponse> => {
  const today = format(new Date(), "yyyy-MM-dd");

  return wro
    .getMyBets(
      {
        startDate: today,
        endDate: today,
        sort: "transactiondate",
        groupSort: "posttime",
        groupSortAscendingOrder: true,
        group: "race",
        status: "pending"
      },
      sessionStorage.getItem("userId") || accountNumber
    )
    .then((response) => response.data);
};
